import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import { BusinessContact } from './BusinessContact';
import { ContactSubmitted } from './ContactSubmitted';
import { messages } from '../../../constants/Forms/contact';
import NavBar from '../../NavBar';
import { Footer } from '../../Footer/Footer';
import { CONTACT_US } from '../../../constants';

export const Contact = () => {
  const [emailExists, setEmailExists] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleFormStateChange = (submitted, emailExistsStatus) => {
    setIsSubmitted(submitted);
    setEmailExists(emailExistsStatus);
  };
  return (
    <>
      <NavBar currentPath={CONTACT_US} />
      {isSubmitted ? (
        <>
          <div className="containterSubmitted">
            <div className="contact_header">
              <h5 className="contact_header_h5"> {messages.messageSent}</h5>
              <p className="contact_header_p">{messages.willContact}</p>
              <div className="contactusDisionSubmitted">
                <ContactSubmitted />
                <BusinessContact />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="containter">
            <div className="contact_header">
              <h5 className="contact_header_h5"> {messages.contactUs}</h5>
              <p className="contact_header_p">{messages.teamWillGetBackToYou}</p>
            </div>
            <div className="contactusDision">
              <ContactForm onFormStateChange={handleFormStateChange} />
              <BusinessContact />
            </div>
          </div>
        </>
      )}
      <Footer currentPath={'/contact'} />
    </>
  );
};
